import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Button } from "reactstrap";
import EditPemilik from "./edit-pemilik";
import EditPenguasa from "./edit-penguasa";
import UploadBidang from "./edit-field";
import EditPajak from "./edit-pajak";

const EditLayer = ({ layer, loading, detailInfo }) => {
  const [activeButton, setActiveButton] = useState("pemilikan");

  const { activeList } = useSelector((state) => state.Map);

  return (
    <div style={{ height: "calc(100vh - 56px)" }}>
      <Alert className="text-center" color="primary">
        <i className="mdi mdi-information-outline mr-2" /> Edit Bidang NBT&nbsp;
        {activeList?.feature?.properties?.properties?.nama}
      </Alert>

      <div className="btn btn-group mb-2">
        <Button
          color="link"
          id="pemilikan"
          title="Pemilik"
          data-bs-placement="top"
          data-bs-toggle="tooltip"
          className={`${
            activeButton === "pemilikan" && "border border-primary"
          }`}
          onClick={() => setActiveButton("pemilikan")}
        >
          <i className="mdi mdi-home-map-marker" />
        </Button>
        <Button
          color="link"
          id="penguasan"
          title="Penguasaan"
          data-bs-placement="top"
          data-bs-toggle="tooltip"
          className={`${
            activeButton === "penguasaan" && "border border-primary"
          }`}
          onClick={() => setActiveButton("penguasaan")}
        >
          <i className="mdi mdi-shield-home" />
        </Button>

        <Button
          id="unggah"
          color="link"
          title="Unggah"
          data-bs-placement="top"
          data-bs-toggle="tooltip"
          className={`${activeButton === "unggah" && "border border-primary"}`}
          onClick={() => setActiveButton("unggah")}
        >
          <i className="mdi mdi-file-upload" />
        </Button>

        <Button
          id="pajak"
          color="link"
          title="Pajak"
          data-bs-placement="top"
          data-bs-toggle="tooltip"
          className={`${activeButton === "pajak" && "border border-primary"}`}
          onClick={() => setActiveButton("pajak")}
        >
          <i className="mdi mdi-cash" />
        </Button>
      </div>

      {/* TAB RENDERED */}

      <div>
        <div
          style={{ display: activeButton === "pemilikan" ? "block" : "none" }}
        >
          <EditPemilik
            layer={layer}
            loading={loading}
            detailInfo={detailInfo}
          />
        </div>
        <div
          style={{ display: activeButton === "penguasaan" ? "block" : "none" }}
        >
          <EditPenguasa
            layer={layer}
            loading={loading}
            detailInfo={detailInfo}
          />
        </div>
        <div style={{ display: activeButton === "unggah" ? "block" : "none" }}>
          <UploadBidang />
        </div>

        <div style={{ display: activeButton === "pajak" ? "block" : "none" }}>
          <EditPajak layer={layer} detailInfo={detailInfo} />
        </div>
      </div>
    </div>
  );
};

export default EditLayer;
